import { Moment } from "moment";
import { AppThunk, AppDispatch } from "../../types";
import fetchReport from "../../../shared/fetchReport";

type FetchAdsNoStateMachineProps = { startDate: Moment; endDate: Moment };

export type FetchAdsNoStateMachine = (
  dates: FetchAdsNoStateMachineProps,
) => void;

const fetchAdsNoStateMachine = ({
  startDate,
  endDate,
}: FetchAdsNoStateMachineProps): AppThunk => async (dispatch: AppDispatch) => {
  const params = {
    start_date: startDate.format("YYYY-MM-DD"),
    end_date: endDate.format("YYYY-MM-DD"),
  };
  await fetchReport("origami_ads_without_state_machine", dispatch, params);
};

export default fetchAdsNoStateMachine;
